module.exports = __webpack_public_path__ + "static/media/Dragons.4b6d4588.jpg";